import React, { useMemo, memo } from "react";
import Dropdown from "../../dropdown/dropdown";
import CardItemSmall from "../../items/card/small";
import countriesData from "../../../libs/countryData.json";
import { Card } from "../../../types";
export { countriesData };

export type CountryData = {
	iso2: string;
	name: string;
	dialCode: string;
	priority: number;
	areaCodes: string[];
};

type OnSelect = (countryData: Card) => void;

const CardDropdown = ({ value, onItemSelect, cards }: { value: Card; onItemSelect: OnSelect; cards: Card[] }) => {
	let selectedValue = null;
	if (value) {
		selectedValue = <CardItemSmall brand={value.brand} last4={value.last4} />;
	}

	let options = useMemo(() => {
		return cards.map((card, key) => <CardItemSmall key={key} brand={card.brand} last4={card.last4} value={card} />);
	}, [cards]);

	return (
		<div className="select card">
			<Dropdown value={selectedValue} onItemSelect={onItemSelect}>
				{options}
			</Dropdown>
		</div>
	);
};

function CardSelect({ input: { onChange, value, name }, prompt, cards, ...rest }) {
	const onItemSelect = (card: Card) => {
		onChange(card);
	};
	return <CardDropdown cards={cards} value={value} onItemSelect={onItemSelect} />;
}

export default memo(CardSelect);
